/**
 * Values mirrored from the backend/reference CLI so the admin panel's UI
 * never drifts from what `/api/*` actually enforces:
 * - `CAPABILITY_GROUPS` matches `backend/src/routes/identity.ts`'s
 *   `CAPABILITY_GROUPS` (the `CHU-GPT-{name}` groups an onboarded user can
 *   be added to, on top of the `CHU-GPT-Users` sign-in gate).
 * - `DEFAULT_USER_BUDGET` / `UNLIMITED_BUDGET` mirror
 *   `scripts/chugpt-admin.py`'s `DEFAULT_USER_CAP` (config's
 *   `max_end_user_budget`) and `UNLIMITED` sentinel.
 * - `DEV_KEY_PREFIX` / `DEV_KEY_DEFAULT_BUDGET` mirror
 *   `backend/src/routes/keys.ts`'s `DEV_KEY_PREFIX` / `DEV_KEY_DEFAULT_BUDGET`.
 */

export const CAPABILITY_GROUPS = [
  'Underwriting',
  'Claims',
  'Actuarial',
  'Data',
  'Finance',
  'Engineering',
  'People',
  'Marketing',
  'SLT',
  'Management',
  // Added 24 Sep 2026 (Round 14): this list had drifted from the backend's
  // own CAPABILITY_GROUP_LABELS since "Developers" (now "API users") landed
  // 23 Sep for the staff portal -- the onboarding tick-box already read the
  // full list live from the backend and so already offered it, but People's
  // own Grant access panel reads THIS hardcoded copy and had silently been
  // missing it for a day.
  'API users',
] as const

export type CapabilityGroup = (typeof CAPABILITY_GROUPS)[number]

/** Dollars. A user with no explicit cap falls back to this at the gateway. */
export const DEFAULT_USER_BUDGET = 100

/** Effectively-unlimited sentinel, same value the gateway treats as "no cap". */
export const UNLIMITED_BUDGET = 1_000_000

export const DEV_KEY_PREFIX = 'dev-'

/** Dollars / 30 days, when a mint request supplies no explicit budget. */
export const DEV_KEY_DEFAULT_BUDGET = 50
